import styled, { css } from 'styled-components';
import { Wrapper as ScopeAvatar } from '../../../../../styled-components/components/ScopeAvatar/wrapper';
import { size } from '../../../../../styled-components/layout/helpers';
import { fadeIn, noTransform } from '../../../../../styled-components/layout/keyframes';
import { ButtonReset } from '../../../../../styled-components/layout/reset';

export const Wrapper = styled.div`
  --scope-foldout-aniamation-duration: 200ms;
  --scope-foldout-zindex-backdrop: 98; // TODO: CHange
  --scope-foldout-zindex-dialog: 99; // TODO: CHange

  display: contents;
`;

// Backdrop

export const Backdrop = styled.div.attrs(() => ({
  role: 'button',
}))`
  position: fixed;
  inset: 0;
  background-color: rgba(var(--c-overlay-rgb), 0.2);
  transition: opacity var(--scope-foldout-aniamation-duration) ease;
  z-index: var(--scope-foldout-zindex-backdrop);
`;

// Dialog

export const Dialog = styled.div`
  --_position-offset: ${size(1.5)};
  --_inner-spacing-inline: ${size(2)};

  display: flex;
  flex-direction: column;
  position: fixed;
  top: var(--_position-offset);
  left: var(--_position-offset);
  width: min(368px, calc(100% - var(--_position-offset) * 2));
  max-height: calc(100% - var(--_position-offset) * 2);
  background-color: var(--c-bg-main);
  border-radius: ${size(3)};
  transform: translateY(${size(-1)});
  animation: ${noTransform} var(--scope-foldout-aniamation-duration) ease forwards, ${fadeIn} var(--scope-foldout-aniamation-duration) ease;
  z-index: var(--scope-foldout-zindex-dialog);

  ${(props) => props.theme.breakpoint.LtMd} {
    width: calc(100% - var(--_position-offset) * 2);
  }
`;

// Header

export const Header = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: ${size(1.5)};
  padding: ${size(3)} var(--_inner-spacing-inline);
  border-bottom: 1px solid var(--c-border-main);

  ${ScopeAvatar} {
    flex-shrink: 0;
  }
`;

export const HeaderName = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: ${size(0.5)};
  min-width: 0;
`;

export const HeaderTitle = styled.div`
  font-weight: var(--font-weight-bold);
  font-size: ${(props) => props.theme.font.size.small};
  line-height: ${(props) => props.theme.font.size.xlarge};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderHierachy = styled(ButtonReset)`
  display: flex;
  align-items: center;
  gap: ${size(0.5)};
  font-size: ${(props) => props.theme.font.size.xsmall};
  line-height: ${(props) => props.theme.font.size.regular};
  text-align: left;

  &:hover {
    text-decoration: underline;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const HeaderHierachyTitle = styled.span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Body

export const Body = styled.div`
  flex: 1 1 auto;
  overflow: auto;
  padding-bottom: calc(var(--_inner-spacing-inline) * 2);
`;

export const Search = styled.div`
  position: sticky;
  top: 0;
  padding: var(--_inner-spacing-inline);
  z-index: 1;
`;

export const OptionDummy = styled.div`
  padding: 0 var(--_inner-spacing-inline);
`;

interface OptionProps {
  $selected: boolean;
}

export const Option = styled(ButtonReset)<OptionProps>`
  display: flex;
  align-items: center;
  gap: ${size(1.5)};
  width: 100%;
  padding: ${size(1.5)} var(--_inner-spacing-inline);

  &:hover {
    background-color: var(--c-accent-bg);
  }

  ${({ $selected }) =>
    $selected &&
    css`
      --_title-font-weight: var(--font-weight-bold);

      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: ${size(0.5)};
        height: ${size(4)};
        transform: translateY(-50%);
        background-color: var(--c-primary-bg);
        border-top-right-radius: 100vmax;
        border-bottom-right-radius: 100vmax;
      }
    `}

    ${ScopeAvatar} {
      flex-shrink: 0;
    }
`;

export const OptionTitle = styled.div`
  font-size: ${(props) => props.theme.font.size.small};
  line-height: ${(props) => props.theme.font.size.xlarge};
  font-weight: var(--_title-font-weight);
  text-align: left;
`;
